import { render, staticRenderFns } from "./modalAprovarAfiliados.vue?vue&type=template&id=227db210"
import script from "./modalAprovarAfiliados.vue?vue&type=script&lang=js"
export * from "./modalAprovarAfiliados.vue?vue&type=script&lang=js"
import style0 from "./modalAprovarAfiliados.vue?vue&type=style&index=0&id=227db210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports